// extracted by mini-css-extract-plugin
export var modalFooter = "_r9-0";